module.exports = __webpack_public_path__ + "c7b24e39.png";